import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ImmoTableSubProject } from '../helper/model/immo-table-sub-project';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ImmoTableControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as ImmoTableSubProject[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/tours/immoItemsTable', requestServices);
  }

  public subProjects(): Promise<ImmoTableSubProject[]> {
    return this.get('', this.deserialize).toPromise();
  }
}
